import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Link } from "@natera/navigation";
import { routes } from "@app/routing";

import "./forgotPasswordLink.scss";

const messages = defineMessages({
  forgotPasswordLink: {
    id: "signInForgotPasswordButton",
    defaultMessage: "Forgot password?",
  },
});

export const ForgotPasswordLink: FC = () => {
  const intl = useIntl();

  return (
    <p className="forgot-password-link">
      <Link target="_blank" rel="noopener noreferrer" to={routes.resetPassword}>
        {intl.formatMessage(messages.forgotPasswordLink)}
      </Link>
    </p>
  );
};
